import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Styles/border-bottom";
import * as React from 'react';
export default {
  Content,
  React
};